<template>
  <section class="video">
    <div class="container">
      <div class="thumbnail" :class="[videoIsPlaying ? 'hide' : '']">
        <span @click="playVideo()">
          <v-icon name="play" />
        </span>
        <img :src="`https://img.youtube.com/vi/${video.videoId}/0.jpg`" alt />
      </div>
      <youtube :video-id="video.videoId" ref="youtube" />
    </div>
  </section>
</template>

<script>
export default {
  props: ["video"],
  data() {
    return {
      videoIsPlaying: false,
    };
  },
  methods: {
    playVideo() {
      this.videoIsPlaying = true;
      this.player.playVideo();
    },
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
  },
};
</script>

<style lang="scss" src="./Video.scss" />